
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top100",
      function () {
        return require("private-next-pages/top100.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top100"])
      });
    }
  